export function fmtCurrency(n) {
  if (n == null || n === "") return null;
  const num = typeof n === "number" ? n : parseFloat(n);
  if (!Number.isFinite(num)) return null;
  return new Intl.NumberFormat("en-AU", {
    style: "currency",
    currency: "AUD",
    maximumFractionDigits: 2,
  }).format(num);
}

export function fmtDate(iso) {
  if (!iso) return "—";
  return new Date(iso).toLocaleDateString("en-AU", {
    day: "numeric",
    month: "short",
    year: "numeric",
  });
}
